import React from "react";
import {
  Layout,
  Card,
  FormLayout,
  SkeletonBodyText,
  Page,
} from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";

export default function LanguageSettingsSkeleton() {
  const { t } = useTranslation();
  
  return (
    <Page>
      <TitleBar title={t("settings.languages.title")} breadcrumbs={[{ content: t("settings.common.breadcrumbs.settings") }]} />
      <Layout>
        <Layout.AnnotatedSection
          title={t("settings.languages.internationalization.title")}
          description={t("settings.languages.internationalization.description")}
        >
          <Card sectioned>
            <FormLayout>
              <SkeletonBodyText />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection
          title={t("settings.languages.supportedLanguages.title")}
          description={t("settings.languages.supportedLanguages.description")}
        >
          <Card sectioned>
            <FormLayout>
              <SkeletonBodyText />
              <SkeletonBodyText />
              <SkeletonBodyText />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection
          title={t("settings.languages.defaultLanguage.title")}
          description={t("settings.languages.defaultLanguage.description")}
        >
          <Card sectioned>
            <FormLayout>
              <SkeletonBodyText />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
    </Page>
  );
} 